import React from 'react';
import PropTypes from 'prop-types';
import ActionMenuWithButton from '../../ActionMenu/ActionMenuWithButton';
import ActionMenuItem from '../../ActionMenu/ActionMenuItem';
import ActionMenuDiver from '../../ActionMenu/ActionMenuDivider';
import childrenOfTypes from '../../../utils/childrenOfTypes';
import withId from '../../../decorators/withId';

import withIdContext from '../../../decorators/withIdContext';

const SecondaryActionWithMenu = ({
  disabled,
  label,
  id,
  ariaLabel,
  children,
  menuRight,
}) => (
  <ActionMenuWithButton
    bsStyle="primary"
    label={label}
    ariaLabel={ariaLabel}
    disabled={disabled}
    id={id}
    menuRight={menuRight}
  >
    {children}
  </ActionMenuWithButton>
);

SecondaryActionWithMenu.propTypes = {
  children: childrenOfTypes(ActionMenuItem, ActionMenuDiver).isRequired,
  /** Button label */
  label: PropTypes.string.isRequired,
  /** Button label */
  ariaLabel: PropTypes.string,
  /** Disable button */
  disabled: PropTypes.bool,
  /** To align the menu to the right side of the Dropdown toggle  */
  menuRight: PropTypes.bool,
  /** Gets called when the user clicks on the button */
  id: PropTypes.string,
};

SecondaryActionWithMenu.defaultProps = {
  disabled: false,
  ariaLabel: null,
  id: null,
  menuRight: false,
};

export default withIdContext('SecondaryActionWithMenu')(withId('Dropdown')(SecondaryActionWithMenu));
